import i18n from '../i18n';

export const validateEmail = (value: string) => {
  if (!value) {
    return undefined;
  }

  const match = value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/gi);
  if (!match) {
    return i18n.t('validEmail');
  }

  return undefined;
};
